import I18n from '../../../config/i18n';
import iconTeaser from './iconTeaser';

const staticHomeData = () => ({
  iconTeaser: iconTeaser(),
  sectionTitle: {
    searchTitle: I18n.t('homepage_customer.search_headline'),
    searchSubtitle: I18n.t('homepage_customer.headline'),
    landingpageTeaser: I18n.t('homepage_customer.landingpage.headline'),
    lastProperties: I18n.t('homepage_customer.last_viewed_objects'),
    hostTeaser: I18n.t('homepage_customer.hosts.headline'),
  },
});

export default staticHomeData;
